// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NavigationBeforeLogin-root-Ugcp1 {
	margin: 0;
}

.NavigationBeforeLogin-link-wRMxB {
	display: inline-block;
	padding: 3px 8px;
	text-decoration: none;
	font-size: 1.125em;
	/* ~18px */
}

.NavigationBeforeLogin-link-wRMxB,
.NavigationBeforeLogin-link-wRMxB:active,
.NavigationBeforeLogin-link-wRMxB:visited {
	color: rgba(255, 255, 255, 0.6);
}

.NavigationBeforeLogin-link-wRMxB:hover {
	color: rgba(255, 255, 255, 1);
}

.NavigationBeforeLogin-highlight-WOs3z {
	margin-right: 8px;
	margin-left: 8px;
	border-radius: 3px;
	background: rgba(0, 0, 0, 0.15);
	color: var(--white-text);
}

.NavigationBeforeLogin-highlight-WOs3z:hover {
	background: rgba(0, 0, 0, 0.3);
}

.NavigationBeforeLogin-spacer-RdmQ_ {
	color: rgba(255, 255, 255, 0.3);
}

.NavigationBeforeLogin-centerMenu-H9nEF {
	position: absolute;
	left: 0;
	right: 0;
	text-align: center;
	top: 50%;
	max-width: 500px;
	margin: 0 auto;
	transform: translateY(-50%);
	-webkit-transform: translateY(-50%);
	-moz-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	-o-transform: translateY(-50%);
}

.NavigationBeforeLogin-centerLink-eUZ0j {
	display: inline-block;
	font-size: 18px;
	color: var(--white-text);
	margin-right: 50px;
	font-weight: 600;
}

.NavigationBeforeLogin-centerLink-eUZ0j a,
.NavigationBeforeLogin-centerLink-eUZ0j a:hover,
.NavigationBeforeLogin-centerLink-eUZ0j a:focus {
	color: var(--white-text);
	text-decoration: none;
}

.NavigationBeforeLogin-dot-sZTPi {
	position: relative;
}

.NavigationBeforeLogin-dot-sZTPi::after {
	content: '';
	width: 6px;
	height: 6px;
	background: var(--primary-white-bg);
	border-radius: 50%;
	position: absolute;
	top: 48%;
	right: -26px;
}

.NavigationBeforeLogin-dot-sZTPi::before {
	content: '';
	width: 57px;
	height: 1.5px;
	background: var(--primary-white-bg);
	position: absolute;
	bottom: -3px;
	right: 0;
	left: 0;
	margin: 0 auto;
}

.NavigationBeforeLogin-breakPointScreen-nh0s3 {
	display: none !important;
}

.NavigationBeforeLogin-nonBreakPointScreen-S0lGX {
	display: block !important;
}

.NavigationBeforeLogin-listCarCss-ftyHg {
	font-weight: 500;
	padding-top: 19px !important;
}

.NavigationBeforeLogin-listCarCss-ftyHg a {
	font-size: 18px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	width: 165px;
	text-align: right;

}

@media(max-width:1200px) {

	.NavigationBeforeLogin-newMenu-y2I0_ {
		height: 100vh;
		background: var(--primary-white-bg) !important;
	}

	.NavigationBeforeLogin-breakPointScreen-nh0s3 {
		display: block !important;
	}

	.NavigationBeforeLogin-nonBreakPointScreen-S0lGX {
		display: none !important;
	}
}

@media(min-width:768px) and (max-width:1200px) {
	.NavigationBeforeLogin-newMenu-y2I0_ {
		left: 0;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/NavigationBeforeLogin/NavigationBeforeLogin.css"],"names":[],"mappings":"AAAA;CACC,SAAS;AACV;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,qBAAqB;CACrB,kBAAkB;CAClB,UAAU;AACX;;AAEA;;;CAGC,+BAA+B;AAChC;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;CAClB,+BAA+B;CAC/B,wBAAwB;AACzB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,QAAQ;CACR,kBAAkB;CAClB,QAAQ;CACR,gBAAgB;CAChB,cAAc;CACd,2BAA2B;CAC3B,mCAAmC;CACnC,gCAAgC;CAChC,+BAA+B;CAC/B,8BAA8B;AAC/B;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,wBAAwB;CACxB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;;;CAGC,wBAAwB;CACxB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,UAAU;CACV,WAAW;CACX,mCAAmC;CACnC,kBAAkB;CAClB,kBAAkB;CAClB,QAAQ;CACR,YAAY;AACb;;AAEA;CACC,WAAW;CACX,WAAW;CACX,aAAa;CACb,mCAAmC;CACnC,kBAAkB;CAClB,YAAY;CACZ,QAAQ;CACR,OAAO;CACP,cAAc;AACf;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,gBAAgB;CAChB,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,gBAAgB;CAChB,uBAAuB;CACvB,YAAY;CACZ,iBAAiB;;AAElB;;AAEA;;CAEC;EACC,aAAa;EACb,8CAA8C;CAC/C;;CAEA;EACC,yBAAyB;CAC1B;;CAEA;EACC,wBAAwB;CACzB;AACD;;AAEA;CACC;EACC,OAAO;CACR;AACD","sourcesContent":[".root {\n\tmargin: 0;\n}\n\n.link {\n\tdisplay: inline-block;\n\tpadding: 3px 8px;\n\ttext-decoration: none;\n\tfont-size: 1.125em;\n\t/* ~18px */\n}\n\n.link,\n.link:active,\n.link:visited {\n\tcolor: rgba(255, 255, 255, 0.6);\n}\n\n.link:hover {\n\tcolor: rgba(255, 255, 255, 1);\n}\n\n.highlight {\n\tmargin-right: 8px;\n\tmargin-left: 8px;\n\tborder-radius: 3px;\n\tbackground: rgba(0, 0, 0, 0.15);\n\tcolor: var(--white-text);\n}\n\n.highlight:hover {\n\tbackground: rgba(0, 0, 0, 0.3);\n}\n\n.spacer {\n\tcolor: rgba(255, 255, 255, 0.3);\n}\n\n.centerMenu {\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\ttext-align: center;\n\ttop: 50%;\n\tmax-width: 500px;\n\tmargin: 0 auto;\n\ttransform: translateY(-50%);\n\t-webkit-transform: translateY(-50%);\n\t-moz-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\t-o-transform: translateY(-50%);\n}\n\n.centerLink {\n\tdisplay: inline-block;\n\tfont-size: 18px;\n\tcolor: var(--white-text);\n\tmargin-right: 50px;\n\tfont-weight: 600;\n}\n\n.centerLink a,\n.centerLink a:hover,\n.centerLink a:focus {\n\tcolor: var(--white-text);\n\ttext-decoration: none;\n}\n\n.dot {\n\tposition: relative;\n}\n\n.dot::after {\n\tcontent: '';\n\twidth: 6px;\n\theight: 6px;\n\tbackground: var(--primary-white-bg);\n\tborder-radius: 50%;\n\tposition: absolute;\n\ttop: 48%;\n\tright: -26px;\n}\n\n.dot::before {\n\tcontent: '';\n\twidth: 57px;\n\theight: 1.5px;\n\tbackground: var(--primary-white-bg);\n\tposition: absolute;\n\tbottom: -3px;\n\tright: 0;\n\tleft: 0;\n\tmargin: 0 auto;\n}\n\n.breakPointScreen {\n\tdisplay: none !important;\n}\n\n.nonBreakPointScreen {\n\tdisplay: block !important;\n}\n\n.listCarCss {\n\tfont-weight: 500;\n\tpadding-top: 19px !important;\n}\n\n.listCarCss a {\n\tfont-size: 18px;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twidth: 165px;\n\ttext-align: right;\n\n}\n\n@media(max-width:1200px) {\n\n\t.newMenu {\n\t\theight: 100vh;\n\t\tbackground: var(--primary-white-bg) !important;\n\t}\n\n\t.breakPointScreen {\n\t\tdisplay: block !important;\n\t}\n\n\t.nonBreakPointScreen {\n\t\tdisplay: none !important;\n\t}\n}\n\n@media(min-width:768px) and (max-width:1200px) {\n\t.newMenu {\n\t\tleft: 0;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `NavigationBeforeLogin-root-Ugcp1`,
	"link": `NavigationBeforeLogin-link-wRMxB`,
	"highlight": `NavigationBeforeLogin-highlight-WOs3z`,
	"spacer": `NavigationBeforeLogin-spacer-RdmQ_`,
	"centerMenu": `NavigationBeforeLogin-centerMenu-H9nEF`,
	"centerLink": `NavigationBeforeLogin-centerLink-eUZ0j`,
	"dot": `NavigationBeforeLogin-dot-sZTPi`,
	"breakPointScreen": `NavigationBeforeLogin-breakPointScreen-nh0s3`,
	"nonBreakPointScreen": `NavigationBeforeLogin-nonBreakPointScreen-S0lGX`,
	"listCarCss": `NavigationBeforeLogin-listCarCss-ftyHg`,
	"newMenu": `NavigationBeforeLogin-newMenu-y2I0_`
};
module.exports = ___CSS_LOADER_EXPORT___;
